import React from "react";
import { AccountSource } from "@common/types/domains/accounting/account";
import { AccountingReportFilters } from "../types";

export const AccountSourceFilterLabel: React.FC<{
    filters: AccountingReportFilters;
}> = ({ filters }) => (
    <>{filters.accountSource === AccountSource.KICK ? "Kick" : "Custom"}</>
);
